import moment from 'moment';
import { getIntegerAsString, getDateAsMoment } from 'data/booking/selectors/form';
import {LUGGAGE_PRICE} from "../constants/misc_types";
import {createMoney} from "data/shared/money";
import {isEmpty} from "lodash";
import {getEditingItem, getRoute} from "data/booking/selectors/booking";

const LMD_DAYS = 4
const LMP_DAYS = 1

function startAt(state){
    const route = getRoute(state)
    return moment().add(route.isLMD ? LMD_DAYS : LMP_DAYS, 'days').toDate()
}

function getDefaultValues(state) {

    let price = null;

    if(state){
        let misc =  state.booking.serviceAdd.data.route ? state.booking.serviceAdd.data.route.misc :
            state.booking.entities.services[state.booking.editingService].route.misc;
        for (let i = 0; i < misc.length; i++) {
            if (misc[i].label === LUGGAGE_PRICE){
                price = createMoney({
                    amount: parseFloat(misc[i].value) * 100,
                    currency: 'EUR'
                });
                break;
            }
        }
    }

    return {
        date: null,
        bags: null,
        from: null,
        fromStep: null,
        to: null,
        toStep: null,
        price: price,
        departureLodgingNotFound : false,
        departureLodgingInformation : "",
        arrivalLodgingNotFound : false,
        arrivalLodgingInformation : "",
        direction: null,
        driverComment: null
    };
}

function getAddValues(state) {
    const { entities, editingService } = state.booking;
    const service = entities.services[editingService];
    const stepCount = service.items.length;

    if (stepCount > 0) {
        const lastStep = entities.items[service.items[stepCount - 1]];
        const nextDate = moment(lastStep.date).add(1, 'days').format();

        return {
            date: nextDate,
            bags: lastStep.bags,
            fromStep: lastStep.toStep ? lastStep.toStep : lastStep.to ? lastStep.to.step : null,
            from: lastStep.to && !isEmpty(lastStep.to.stop) ? {
                ...lastStep.to,
                type: 'stop',
                id: lastStep.to.stop.id
            } : null,
            to: null,
            toStep: null,
            price: lastStep.price,
            departureLodgingNotFound : lastStep.arrivalLodgingNotFound ? lastStep.arrivalLodgingNotFound : false,
            departureLodgingInformation : lastStep.arrivalLodgingInformation ? lastStep.arrivalLodgingInformation : "",
            arrivalLodgingNotFound : false,
            arrivalLodgingInformation : "",
            direction: lastStep.direction,
            driverComment: null
        };
    }

    return getDefaultValues(state);
}

function getEditValues(state, currentItem = null) {
    const { entities, editingItem } = state.booking;
    const item = currentItem ? currentItem : entities.items[editingItem];

    let direction = 1;
    const {steps} = state.map.entities;
    if(!isEmpty(steps)){
        const stepArray = Object.keys(steps)
        let fromIndex = stepArray.indexOf(item.fromStep ? item.fromStep.id : item.from.step.id)
        let toIndex = stepArray.indexOf(item.toStep ? item.toStep.id : item.to.step.id)
        direction = toIndex > fromIndex ? 1 : -1
    }

    return {
        date: getDateAsMoment(item.date).format(),
        bags: item.bags,
        fromStep: item.fromStep ? item.fromStep : item.from ? item.from.step : null,
        from: item.from && item.from.id ? item.from : null,
        to: item.to && item.to.id ? item.to : null,
        toStep: item.toStep ? item.toStep : item.to ? item.to.step : null,
        departureLodgingNotFound : item.departureLodgingNotFound || (item.from && isEmpty(item.from.stop)),
        departureLodgingInformation : item.departureLodgingInformation ? item.departureLodgingInformation : item.from?.step?.comment,
        arrivalLodgingNotFound : item.arrivalLodgingNotFound || (item.to && isEmpty(item.to.stop)),
        arrivalLodgingInformation : item.arrivalLodgingInformation ? item.arrivalLodgingInformation : item.to?.step?.comment,
        direction: {value: direction},
        driverComment: null
    };
}

function equals(itemA, itemB){
    return getDateAsMoment(itemA.date).format() == getDateAsMoment(itemB.date).format()
         && itemA.bags == itemB.bags
        && itemA.price == itemB.price
        && ((itemA.from && itemB.from && itemA.from.id == itemB.from.id) || (!itemA.from && !itemB.from))
        && ((itemA.to && itemB.to && itemA.to.id == itemB.to.id) || (!itemA.to && !itemB.to))
}

export {
    getDefaultValues,
    getEditValues,
    getAddValues,
    startAt,
    equals
};
